import {
  BottomNavigation,
  Navigation,
  NavigationItem,
} from '@globalmed/atlas-ui';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './NavPanel.module.css';
import { InstitutionLogoContent } from '@/components/InstitutionLogoContent';
import { useActiveNavigation } from '@/hooks/useActiveNavigation';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useNavigationItems } from '@/hooks/useNavigationItems';
import { INavigationItemPlus } from '@/types';
import { useInstitutionsStore } from '@/stores/institutions';

/**
 * Atlas types the change handler with the base NavigationItem, while the items
 * we pass in are INavigationItemPlus and carry a route.
 * @param item - The navigation item reported by Atlas.
 * @returns True when the item carries a route.
 */
const hasRoute = (item: NavigationItem): item is INavigationItemPlus =>
  typeof (item as INavigationItemPlus).route === 'string';

export const NavPanel = () => {
  const isSmallScreen = useMediaQuery('(max-width: 1280px)');
  const navigate = useNavigate();
  const location = useLocation();

  const { availableItems, translatedNavItems } = useNavigationItems();
  const { activeKey, setActiveKey } = useActiveNavigation(availableItems);

  const whitelabel = useInstitutionsStore(
    (state) => state.currentInstitution?.whitelabel,
  );

  const [isPreferBanner, setIsPreferBanner] = useState(true);

  const handleChange = (item: NavigationItem) => {
    setActiveKey(item.key);
    if (hasRoute(item)) navigate(item.route);
  };

  if (!activeKey && !location.pathname.match(/^\/encounter\/.+/)) {
    return null;
  }

  return (
    <>
      {isSmallScreen ? (
        <BottomNavigation
          items={translatedNavItems}
          onChange={handleChange}
          activeKey={activeKey}
        />
      ) : (
        <Navigation
          className={styles.navPanel}
          items={translatedNavItems}
          onChange={handleChange}
          activeKey={activeKey}
          onOpenChange={(open) => setIsPreferBanner(open)}
        >
          <div className={styles.logoWrapper}>
            <InstitutionLogoContent
              whitelabel={whitelabel}
              isPreferBanner={isPreferBanner}
            />
          </div>
        </Navigation>
      )}
    </>
  );
};
